var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "section",
      {
        staticClass: "container-fluid vue-designer",
        attrs: { id: "application" },
      },
      [
        _c("FontLoader", { attrs: { fonts: _vm.getFonts } }),
        _vm._v(" "),
        _vm.producOutOfStock
          ? _c("div", { staticClass: "notification is-warning" }, [
              _vm.getLanguageStrings.out_of_stock
                ? _c("span", [
                    _vm._v(_vm._s(_vm.getLanguageStrings.out_of_stock)),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "form",
          { staticClass: "sign-generator", attrs: { id: "generator" } },
          [
            _vm.ajaxUrl &&
            _vm.appSettings &&
            _vm.getSign &&
            _vm.getFonts &&
            _vm.getTextSizes
              ? _c(
                  "div",
                  {
                    staticClass: "vue-designer",
                    attrs: { id: "vue-designer" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "columns has-background-white is-multiline has-border-grey",
                      },
                      [
                        _c("div", { staticClass: "column" }, [
                          _c(
                            "div",
                            { staticClass: "columns designer-main-container" },
                            [
                              _c("MobileToolbar", {
                                attrs: {
                                  currentDesign: _vm.currentDesign,
                                  languageStrings: _vm.getLanguageStrings,
                                },
                                on: { clearDesign: _vm.clearSavedDesign },
                              }),
                              _vm._v(" "),
                              _c("Designer", {
                                attrs: {
                                  aggregatedPrice: _vm.aggregatedPrice,
                                  appSettings: _vm.appSettings,
                                  getSign: _vm.getSign,
                                  getFonts: _vm.getFonts,
                                  getTextSizes: _vm.getTextSizes,
                                  languageStrings: _vm.getLanguageStrings,
                                  currentDesign: _vm.currentDesign,
                                  textRows: _vm.textRows,
                                  advancedEditor: _vm.advancedEditor,
                                  priceObject: _vm.priceObject,
                                },
                                on: { addToCart: _vm.addtocart },
                              }),
                              _vm._v(" "),
                              _vm.getLanguageStrings.designer_tip
                                ? _c(
                                    "div",
                                    { staticClass: "switch-sign-message" },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getLanguageStrings.designer_tip
                                          )
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("DesignerSidebar", {
                                attrs: {
                                  appSettings: _vm.appSettings,
                                  getSign: _vm.getSign,
                                  getFonts: _vm.getFonts,
                                  getTextSizes: _vm.getTextSizes,
                                  languageStrings: _vm.getLanguageStrings,
                                  currentDesign: _vm.currentDesign,
                                  savedTextrows: _vm.textRows,
                                  advancedEditor: _vm.advancedEditor,
                                },
                                on: {
                                  changeFontTextsize: _vm.changeFont,
                                  changeTextRows: _vm.changeTextRows,
                                },
                              }),
                              _vm._v(" "),
                              _c("ImageGenerator", {
                                attrs: {
                                  appSettings: _vm.appSettings,
                                  getSign: _vm.getSign,
                                  textRows: _vm.textRows,
                                  currentDesign: _vm.currentDesign,
                                  advancedEditor: _vm.advancedEditor,
                                  getTextSizes: _vm.getTextSizes,
                                  languageStrings: _vm.getLanguageStrings,
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.getGalleryImages()
                          ? _c("MediaGallery", {
                              attrs: {
                                galleryImages: _vm.getGalleryImages(),
                                dialogOpen: _vm.dialogToggle,
                              },
                              on: { dialogHandler: _vm.openDialog },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c("ProductInformation", {
          attrs: {
            getSign: _vm.getSign,
            languageStrings: _vm.getLanguageStrings,
            settings: _vm.appSettings,
            siteSettings: _vm.getSiteSettings,
          },
        }),
        _vm._v(" "),
        _c("ProductInformationMobile", {
          attrs: {
            getSign: _vm.getSign,
            languageStrings: _vm.getLanguageStrings,
            settings: _vm.appSettings,
            siteSettings: _vm.getSiteSettings,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }